<template>
    <div>
        <span class="image-size-text">
            Img
        </span>
    </div>
</template>

<script>
export default {
    name: 'ImageSize'
}   
</script> 

<style scoped>
.image-size-text {
    position: relative;
    top: -30px !important;
}
</style>